import React from "react";
import { api } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Button, Modal, Snippet } from "shared/ui";

export interface IEmployeeInviteLinkModal extends UseModalProps {
  companySlug: string;
}

export const EmployeeInviteLinkModal = (props: IEmployeeInviteLinkModal) => {
  const invite = api.companyInvite.useCompanyInviteInvite(props.companySlug);

  const submit = useApiMethod(api.companyInvite.companyInviteReset);

  const onReset = async () => {
    await submit.call(props.companySlug);
    await invite.mutate();
  };

  return (
    <Modal onClose={props.close} width={480}>
      <Modal.Header>
        <Modal.Title>Ссылка для приглашения</Modal.Title>
        <Modal.Subtitle style={{ color: "var(--geist-secondary)" }}>
          Разрешите другим людям присоединиться к вашей команде по ссылке ниже.
        </Modal.Subtitle>
      </Modal.Header>

      <Modal.Body style={{ paddingTop: "0px" }}>
        <Snippet fill={true} text={`control.online/invite/${invite.data?.invite}`} width={"100%"} />

        <Button size="small" type="secondary" style={{ marginTop: "24px" }} onClick={onReset}>
          Сбросить ссылку
        </Button>
      </Modal.Body>
      <Modal.Actions>
        <Modal.Action htmlType="button" onClick={props.close}>
          Ок
        </Modal.Action>
      </Modal.Actions>
    </Modal>
  );
};

EmployeeInviteLinkModal.defaultProps = {};
